<template>
  <div style="height: 100%;">
    <div class="my-gallery" style="height: 100%;">
      <template v-for="(item,index) in slides" style="height: 100%;">
        <!-- <figure>
          <a :href="item.src" >
            <slot v-bind:item="item">
            <img :src="item.msrc" />
            </slot>
          </a>
          <figcaption style="display: none" itemprop="caption description">{{item.title}}</figcaption>
        </figure> -->
        <figure :key="index" style="height: 100%;">
          <a :href="item.src">
            <slot v-bind:item="item">
              <img :src="item.src" />
            </slot>
          </a>
          <figcaption style="display: none">{{item.title}}</figcaption>
        </figure>
      </template>
    </div>
    <div class="pswp" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="pswp__bg"></div>
      <div class="pswp__scroll-wrap">
        <div class="pswp__container">
          <div class="pswp__item"></div>
          <div class="pswp__item"></div>
          <div class="pswp__item"></div>
        </div>
        <div class="pswp__ui pswp__ui--hidden">

          <div class="pswp__top-bar">
            <div class="pswp__counter"></div>
            <button class="pswp__button pswp__button--close" title="退出"></button>
            <button class="pswp__button iconfont icon-xiazai_" style="background: none; color: #fff;" title="下载" @click="download"></button>
            <button class="pswp__button pswp__button--share" title="工具"></button>
            <button class="pswp__button pswp__button--fs" title="全屏"></button>
            <button class="pswp__button pswp__button--zoom" title="放大/缩小"></button>
            <div class="pswp__preloader">
              <div class="pswp__preloader__icn">
                <div class="pswp__preloader__cut">
                  <div class="pswp__preloader__donut"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="pswp__share-modal pswp__share-modal--hidden pswp__single-tap">
            <div class="pswp__share-tooltip"></div>
          </div>
          <button class="pswp__button pswp__button--arrow--left" title="上一张">
          </button>
          <button class="pswp__button pswp__button--arrow--right" title="下一张">
          </button>
          <div class="pswp__caption">
            <div class="pswp__caption__center"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PhotoSwipe from 'photoswipe/dist/photoswipe'
import PhotoSwipeUIDefault from 'photoswipe/dist/photoswipe-ui-default'

let gallery = null;
export default {
  name: 'k-preview',
  props: {
    slides: Array
  },
  data() {
    return {
    }
  },
  methods: {
    initPhotoSwipeFromDOM(gallerySelector) {
      let that = this;
      // parse slide data (url, title, size ...) from DOM elements
      // (children of gallerySelector)
      const getImageInfo = function (el) {
        let item = {};
        return new Promise((resolve, reject) => {
          let image = new Image();
          image.src = el.src;
          image.onload = function (e) {
            item = {
              src: el.src,
              w: parseInt(image.width, 10),
              h: parseInt(image.height, 10)
            }
            return resolve(item);
          }
        });
      }
      const parseThumbnailElements = async function (el) {
        let thumbElements = el.childNodes;
        let numNodes = thumbElements.length;
        let items = [];
        let figureEl;
        let linkEl;
        let item;
        for (let i = 0; i < numNodes; i++) {
          // <figure> element
          figureEl = thumbElements[i]
          // include only element nodes
          if (figureEl.nodeType !== 1) {
            continue
          }
          // <a> element
          linkEl = figureEl.children[0]
          // size = linkEl.getAttribute('data-size').split('x')
          // create slide object
          // 原始图片大小
          item = await getImageInfo(linkEl.childNodes[0]);

          if (figureEl.children.length > 1) {
            // <figcaption> content
            item.title = figureEl.children[1].innerHTML
          }
          if (linkEl.children.length > 0) {
            // <img> thumbnail element, retrieving thumbnail url
            item.msrc = linkEl.children[0].getAttribute('src')
          }
          item.el = figureEl
          items.push(item)
        }

        return items
      }
      // find nearest parent element
      const closest = function closest(el, fn) {
        return el && (fn(el) ? el : closest(el.parentNode, fn))
      }
      // triggers when user clicks on thumbnail
      const onThumbnailsClick = function (e) {
        console.log('jin lai')
        e = e || window.event
        e.preventDefault ? e.preventDefault() : e.returnValue = false
        let eTarget = e.target || e.srcElement
        // find root element of slide
        let clickedListItem = closest(eTarget, function (el) {
          return (el.tagName && el.tagName.toUpperCase() === 'FIGURE')
        })
        if (!clickedListItem) {
          return
        }
        // find index of clicked item by looping through all child nodes
        // alternatively, you may define index via data- attribute
        let clickedGallery = clickedListItem.parentNode
        let childNodes = clickedListItem.parentNode.childNodes
        let numChildNodes = childNodes.length
        let nodeIndex = 0
        let index
        for (let i = 0; i < numChildNodes; i++) {
          if (childNodes[i].nodeType !== 1) {
            continue
          }
          if (childNodes[i] === clickedListItem) {
            index = nodeIndex
            break
          }
          nodeIndex++
        }
        if (index >= 0) {
          // open PhotoSwipe if valid index found
          openPhotoSwipe(index, clickedGallery)
        }
        return false
      }
      // parse picture index and gallery index from URL (#&pid=1&gid=2)
      const photoSwipeParseHash = function () {
        let hash = window.location.hash.substring(1)
        let params = {}
        if (hash.length < 5) {
          return params
        }
        let vars = hash.split('&')
        for (let i = 0; i < vars.length; i++) {
          if (!vars[i]) {
            continue
          }
          let pair = vars[i].split('=')
          if (pair.length < 2) {
            continue
          }
          params[pair[0]] = pair[1]
        }
        if (params.gid) {
          params.gid = parseInt(params.gid, 10)
        }
        return params
      }
      const openPhotoSwipe = function (index, galleryElement, disableAnimation, fromURL) {
        let pswpElement = document.querySelectorAll('.pswp')[0];
        let photoSwipeOptions
        // let gallery
        parseThumbnailElements(galleryElement).then((items) => {
          console.log('items');
          console.log(items);
          // 自定义配置文件
          photoSwipeOptions = {
            mainClass: 'pswp--minimal--dark',
            barsSize: { top: 0, bottom: 0 },
            captionEl: false,
            fullscreenEl: true,
            shareEl: false,
            bgOpacity: 0.85,
            tapToClose: true,
            tapToToggleControls: false,
            maxSpreadZoom: 2,
            shareButtons: [
              { id: 'wechat', label: '分享微信', url: '#' },
              { id: 'weibo', label: '新浪微博', url: '#' },
              { id: 'download', label: '保存图片', url: '{{raw_image_url}}', download: true }
            ],
            errorMsg: '<div class="pswp__error-msg">无法加载此图像。</div>',
            // define gallery index (for URL)
            galleryUID: galleryElement.getAttribute('data-pswp-uid'),
            getThumbBoundsFn: function (index) {
              // See Options -> getThumbBoundsFn section of documentation for more info
              let thumbnail = items[index].el.getElementsByTagName('img')[0]
              let pageYScroll = window.pageYOffset || document.documentElement.scrollTop
              let rect = thumbnail.getBoundingClientRect()
              return { x: rect.left, y: rect.top + pageYScroll, w: rect.width }
            },
            getDoubleTapZoom: function (isMouseClick, item) {
              // isMouseClick          - true if mouse, false if double-tap
              // item                  - slide object that is zoomed, usually current
              // item.initialZoomLevel - initial scale ratio of image
              //                         e.g. if viewport is 700px and image is 1400px,
              //                              initialZoomLevel will be 0.5
              if (isMouseClick) {
                // is mouse click on image or zoom icon
                // zoom to original
                return 2;

                // e.g. for 1400px image:
                // 0.5 - zooms to 700px
                // 2   - zooms to 2800px
              } else {
                // is double-tap
                // zoom to original if initial zoom is less than 0.7x,
                // otherwise to 1.5x, to make sure that double-tap gesture always zooms image
                return item.initialZoomLevel < 0.7 ? 1 : 1.5;
              }
            }
          }
          // PhotoSwipe opened from URL
          if (fromURL) {
            if (photoSwipeOptions.galleryPIDs) {
              // parse real index when custom PIDs are used
              // http://photoswipe.com/documentation/faq.html#custom-pid-in-url
              for (let j = 0; j < items.length; j++) {
                if (items[j].pid === index) {
                  photoSwipeOptions.index = j
                  break
                }
              }
            } else {
              // in URL indexes start from 1
              photoSwipeOptions.index = parseInt(index, 10) - 1
            }
          } else {
            photoSwipeOptions.index = parseInt(index, 10)
          }
          // exit if index not found
          if (isNaN(photoSwipeOptions.index)) {
            return
          }
          if (disableAnimation) {
            photoSwipeOptions.showAnimationDuration = 0
          }
          // Pass data to PhotoSwipe and initialize it
          gallery = new PhotoSwipe(pswpElement, PhotoSwipeUIDefault, items, photoSwipeOptions)
          gallery.init()
          // Gallery starts closing
          gallery.listen('close', function () {
            that.$emit('close')
          })
        });
      }
      // loop through all gallery elements and bind events
      const galleryElements = document.querySelectorAll(gallerySelector)
      for (let i = 0, l = galleryElements.length; i < l; i++) {
        galleryElements[i].setAttribute('data-pswp-uid', i + 1)
        galleryElements[i].onclick = onThumbnailsClick
      }
      // Parse URL and open gallery if it contains #&pid=3&gid=1
      const hashData = photoSwipeParseHash()
      if (hashData.pid && hashData.gid) {
        openPhotoSwipe(hashData.pid, galleryElements[hashData.gid - 1], true, true)
      }
    },
    download() {
      // gallery存vue 会丢失。
      let src = gallery.currItem.src;
      require('downloadjs')(src, src.split('/')[src.split('/').length - 1]);
    }
  },
  mounted() {
    this.initPhotoSwipeFromDOM('.my-gallery');
  }
}
</script>
<style>
@import '../../../../node_modules/photoswipe/dist/photoswipe.css';
@import '../../../../node_modules/photoswipe/dist/default-skin/default-skin.css';

figure {
  display: block;
  -webkit-margin-before: 0;
  -webkit-margin-after: 0;
  -webkit-margin-start: 0;
  -webkit-margin-end: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/photo-preview/src/preview.vue